<template>
  <eb-panel class="proj-rule-edit-type-item" v-bind:class="{ panelHide: !isExpand }">
    <eb-panel-header class="panel-header" slot="header">
      <span slot="title">{{ ruleTypeItemIndex +1 }} {{ruleTypeItem.ruleType}}</span>
      <template slot="button">
        <EbBtnExpand :isExpand.sync="isExpand" />
      </template>
    </eb-panel-header>
    <div slot="body" >
      <RuleEditListDigitalItem  v-for="(item, $index) in ruleTypeItem.ruleItem" :key="$index" :ruleDigitalItem="item" :ruleDigitalItemIndex="$index"
        :ruleTypeItemIndex="ruleTypeItemIndex" :uploadUrl="uploadUrl" />
    </div>
  </eb-panel>
</template>

<script>
import EbPanel from '@/components/common/panel/eb-panel';
import EbPanelHeader from '@/components/common/panel/eb-panel-header';
import EbBtnExpand from '@/components/common/eb-btn-expand';
import RuleEditListDigitalItem from './ProjRuleEditListDigitalItem';

export default {
  components: {
    EbPanel,
    EbPanelHeader,
    EbBtnExpand,
    RuleEditListDigitalItem
  },
  props: {
    ruleTypeItem: {
      type: Object,
      required: true
    },
    ruleTypeItemIndex: {
      type: Number,
      required: true
    },
    uploadUrl: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      isExpand: true
    };
  }
};
</script>

<style lang="less">
.proj-rule-edit-type-item {
  .iconfont {
    cursor: pointer;
  }
}
</style>
